import React from "react";
import {
  Edit,
  TextInput,
  SimpleForm,
  required,
  ReferenceInput,
  SelectInput,
  ArrayInput,
  SimpleFormIterator,
  NumberInput,
} from "react-admin";
import Grid from "@material-ui/core/Grid";

const SystemEdit = (props) => (
  <Edit
    id="generalSettings"
    resource="system"
    basePath="/settings"
    title="System Settings"
    redirect={false} // I don't need any redirection here, there's no list page
    {...props}
  >
    <SimpleForm>
      <div style={{}}>
        <ReferenceInput
          label="Entry Tank"
          source="firstTankId"
          reference="tanks"
          fullWidth
          validate={required()}
        >
          <SelectInput optionText="name" optionValue="id" />
        </ReferenceInput>
      </div>

      <div style={{}}>
        <NumberInput
          label="Ama Coins Per Invitation"
          source="amaCoinsPerInvitation"
          isRequired
          validate={required()}
          fullWidth
        />
      </div>

      <div style={{}}>
        <NumberInput
          label="Ama Coins Per Game Point"
          source="amaCoinsPerGamePoint"
          isRequired
          validate={required()}
          fullWidth
        />
      </div>

      <div style={{}}>
        <NumberInput
          label="Transfer Fees in USD"
          source="usdTransferFees"
          isRequired
          validate={required()}
          fullWidth
        />
      </div>

      <div style={{}}>
        <TextInput
          label="Rate App Linking Url"
          source="rateAppLinkingUrl"
          isRequired
          validate={required()}
          fullWidth
        />
      </div>
      <div style={{ width: "100%" }}>
        <ArrayInput source="contactSubjectOptions">
          <SimpleFormIterator source="name">
            <TextInput label="Option Title" source="name" />
          </SimpleFormIterator>
        </ArrayInput>
      </div>
      <div style={{ width: "100%" }}>
        <TextInput
          label="About App"
          source="aboutApp"
          isRequired
          validate={required()}
          multiline
          fullWidth
        />
      </div>
      <div style={{ width: "100%" }}>
        <TextInput
          label="Terms and Conditions"
          source="termsAndConditions"
          isRequired
          validate={required()}
          multiline
          fullWidth
        />
      </div>
      <div style={{ width: "100%" }}>
        <TextInput
          label="Privacy Policy"
          source="privacyPolicy"
          isRequired
          validate={required()}
          multiline
          fullWidth
        />
      </div>
    </SimpleForm>
  </Edit>
);

export default SystemEdit;
